import { Subscriber } from 'rxjs';

export const unsubscribeComponent = (component) => {
  Object.values(component).forEach((value) =>
    value instanceof Subscriber ? value.unsubscribe() : ''
  );
};
export default unsubscribeComponent;
